var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"inviteBtn",style:(_vm.bgStyle),on:{"click":_vm.handleClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }